"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _PlayerStatsTable = _interopRequireDefault(require("./PlayerStatsTable.js"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _i18next = _interopRequireDefault(require("i18next"));
var _Card = require("material-ui/Card");
var _ThemeService = require("../common/ThemeService.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ReportCardContent = /*#__PURE__*/function (_React$Component) {
  _inherits(ReportCardContent, _React$Component);
  var _super = _createSuper(ReportCardContent);
  function ReportCardContent(props) {
    var _this;
    _classCallCheck(this, ReportCardContent);
    _this = _super.call(this, props);
    _this.setopenClose = function () {
      if (!_this.state.openClose) {
        _this.setState({
          openClose: true
        });
        _this.forceUpdate();
      } else {
        _this.setState({
          openClose: false
        });
        _this.forceUpdate();
      }
    };
    _this.getCorlorCodForGrade = function (grade) {
      if (grade === 'A') return '#7ED321';
      if (grade === 'B') return '#7ED321';
      if (grade === 'C') return '#FFC814';
      if (grade === 'D') return '#FE8F40';
      if (grade === 'E') return '#FF4E3E';
    };
    _this.onCardClick = function (val, obj) {
      var activityTrack = [];
      if (localStorage.getItem('activityTrack')) activityTrack = JSON.parse(localStorage.getItem('activityTrack'));
      var index = _this.state.summaryRange.indexOf(obj);
      for (var i = 0; i < _this.state.summaryRange.length; i++) {
        if (i == index) {
          if (_this.state.summaryRange[i].expandFlag === true) _this.state.summaryRange[i].expandFlag = false;else {
            if (!_this.props.sharedReport) {
              var _activityTrack = [];
              if (localStorage.getItem('activityTrack')) _activityTrack = JSON.parse(localStorage.getItem('activityTrack'));
              var track = {
                hit_timestamp: (0, _moment["default"])().format(),
                session_id: localStorage.getItem("token"),
                userid: localStorage.getItem("username"),
                deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
                hit_page: 'ReportCard',
                hit_type: 'ReportCardCategoryExpand',
                hit_attribute1: obj.category,
                hit_attribute2: obj.grade,
                hit_attribute3: _this.props.summaryInfo.points,
                hit_attribute4: _this.props.summaryInfo.medal,
                hit_attribute5: ''
              };
              _activityTrack.push(track);
              localStorage.setItem('activityTrack', JSON.stringify(_activityTrack));
            }
            _this.state.summaryRange[i].expandFlag = true;
          }
        } else {
          _this.state.summaryRange[i].expandFlag = false;
        }
      }
      _this.forceUpdate();
      _this.setState({
        category: obj.category
      });
      _this.setopenClose();
    };
    _this.state = {
      category: "",
      openClose: false,
      summaryRange: props.summaryRange,
      playerStatistics: props.playerStatistics
    };
    return _this;
  }
  _createClass(ReportCardContent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var stats = _toConsumableArray(nextProps.playerStatistics);
      // console.log("stats--------------------->",stats)
      var copyWinRate = stats.filter(function (data) {
        return data.stat === "Win Rate Ev Allin Adjusted";
      })[0];
      stats = stats.filter(function (data) {
        return data.stat !== "Win Rate Ev Allin Adjusted";
      });
      if (copyWinRate) {
        // if(this.props.hitRange !== "Last Year" && this.props.hitRange !== "All Time"){
        if (this.props.hitRange !== "All Time") {
          stats.push(_objectSpread({}, copyWinRate));
          stats.push(_objectSpread(_objectSpread({}, copyWinRate), {}, {
            stat: "Win Rate EV Copy"
          }));
        } else {
          stats.push({
            stat: "Win Rate EV Copy",
            showOnlyNote: true
          });
        }
      }
      this.setState({
        playerStatistics: stats
      });
      this.setState({
        summaryRange: nextProps.summaryRange
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: '#020202'
        }
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "gameAnalyisCss",
        style: {
          // color: "#020202",
          // fontSize: "20px",
          fontWeight: 'bold',
          fontFamily: 'Roboto'
        }
      }, _i18next["default"].t("lable.myGameAnalysis"), this.props.updatedAt != '' && /*#__PURE__*/_react["default"].createElement("span", {
        className: "updatedDateNote"
      }, " (", _i18next["default"].t("lable.Note"), ": ", _i18next["default"].t("lable.lastUpdatedOn"), ": ", this.props.updatedAt ? (0, _moment["default"])(this.props.updatedAt).format('DD-MM-YYYY') : "N/A", ")")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "blackLineafterGameAnalysis"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row hide-prop_heading dimgreyBorderBottom",
        style: {
          margin: '0px 10px 10px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-4 columnTitlesOfMGA",
        style: {
          width: '31%',
          marginLeft: '-16px'
        }
      }, _i18next["default"].t("lable.Title")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-5",
        style: {
          fontFamily: 'Roboto',
          width: '46%',
          marginLeft: '0px',
          color: '#b0b0b0'
        }
      }, _i18next["default"].t("lable.Description")), !this.props.sharedReport && /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-1",
        style: {
          fontFamily: 'Roboto',
          width: '8%',
          marginLeft: '34px',
          color: '#b0b0b0'
        }
      }, _i18next["default"].t("lable.Lesson"), "\xA0", _i18next["default"].t("lable.Grade"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stats_table_wrapper",
        style: {
          margin: this.props.isLiveview ? '-10px 0 0 -10px' : '-10px'
        }
      }, this.state.summaryRange.length > 0 && this.state.summaryRange.map(function (obj, index) {
        return /*#__PURE__*/_react["default"].createElement(_Card.Card, {
          className: "common_Card",
          key: index,
          expanded: obj.expandFlag !== undefined ? obj.expandFlag : false,
          style: {
            margin: '10px',
            borderRadius: '5px',
            boxShadow: 'none'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          onClick: function onClick() {
            return _this2.onCardClick(index + 1, obj);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Card.CardHeader, {
          className: "common_CardHeader",
          style: {
            padding: "10px",
            marginTop: "-10px"
          },
          actAsExpander: true,
          showExpandableButton: false,
          iconStyle: {
            display: 'none'
          }
        }, /*#__PURE__*/_react["default"].createElement(CardHeaderContent, {
          i18next: _i18next["default"],
          className: "common_CardHeaderContent",
          expandFlag: obj.expandFlag,
          title: obj.category,
          subtitle: obj.comment,
          grade: obj.grade,
          colorCode: _this2.getCorlorCodForGrade(obj.grade),
          openClose: _this2.state.openClose,
          setopenClose: _this2.setopenClose,
          sharedReport: _this2.props.sharedReport,
          enable: obj.enable
        }))), _this2.props.sharedReport && obj.enable === "false" ? '' : /*#__PURE__*/_react["default"].createElement(_Card.CardText, {
          expandable: true,
          className: "common_CardText",
          style: _defineProperty({
            padding: '0px'
          }, "padding", '0px 10px 0px 10px')
        }, /*#__PURE__*/_react["default"].createElement(_PlayerStatsTable["default"], {
          i18next: _i18next["default"],
          className: "common_PlayerStatsTable",
          gameType: _this2.props.gameType,
          isLiveview: _this2.props.isLiveview,
          path: _this2.props.path,
          summaryInfo: _this2.props.summaryInfo,
          category: _this2.state.category,
          playerStatistics: _this2.state.playerStatistics,
          luckfactor: _this2.props.luckfactor,
          handsAnalysed: _this2.props.handsAnalysed,
          sharedReport: _this2.props.sharedReport,
          hitRange: _this2.props.hitRange,
          accountName: _this2.props.accountName,
          saveCourseRedirection: _this2.props.saveCourseRedirection
        })));
      })));
    }
  }]);
  return ReportCardContent;
}(_react["default"].Component);
var CardHeaderContent = function CardHeaderContent(props) {
  var themeColor = (0, _ThemeService.getColor)();
  var themeDarkColor = (0, _ThemeService.getDarkTextColor)();
  var themeTextColor = (0, _ThemeService.getTextColor)();
  return /*#__PURE__*/_react["default"].createElement("table", {
    className: "resp-table dimgreyBorderBottom",
    style: {
      width: "100%",
      marginTop: '-30px',
      marginBottom: '-10px',
      color: "#020202",
      backgroundColor: "white"
    }
  }, /*#__PURE__*/_react["default"].createElement("tbody", {
    "data-e2e": "categoryTable"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "categoryTable_data",
    style: {
      backgroundColor: "#fff !important"
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "categoryTable_title",
    style: {
      width: '30%',
      whiteSpace: 'pre-wrap',
      borderBottom: 'none',
      fontWeight: 'bold',
      fontFamily: 'Roboto'
    },
    "data-e2e": props.title
  }, _i18next["default"].t("lable." + props.title.toLowerCase())), /*#__PURE__*/_react["default"].createElement("td", {
    style: {
      paddingTop: "18px",
      paddingBottom: "18px",
      width: '50%',
      whiteSpace: 'pre-wrap',
      borderBottom: 'none',
      fontFamily: 'Roboto'
    },
    className: "hide-prop_for_mobile_descriptionOfMGAS resp-table-td descriptionOfMGAS "
  }, props.subtitle), /*#__PURE__*/_react["default"].createElement("td", {
    style: {
      width: '8%',
      marginRight: '10px',
      whiteSpace: 'initial',
      borderBottom: 'none',
      fontFamily: 'Roboto'
    },
    className: "resp-padding"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cursive",
    style: {
      color: props.colorCode,
      fontSize: '28px',
      fontWeight: 'bold'
    }
  }, props.grade)), /*#__PURE__*/_react["default"].createElement("td", {
    style: {
      width: '12%',
      borderBottom: 'none'
    }
  }, props.sharedReport && props.enable === "false" ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-lg fa-lock"
  }) : /*#__PURE__*/_react["default"].createElement("button", {
    "data-e2e": props.expandFlag ? "closeClick" : "openClick",
    className: 'mg-btn saffron greyBtnLiveReport btnHalo livestateTable_collapse_btn ' + (props.expandFlag ? "closeButtonhoverEffect" : ""),
    style: {
      width: "80px",
      height: '33px',
      "float": 'right',
      backgroundColor: props.expandFlag ? "#FFFFFF" : themeColor,
      color: props.expandFlag ? themeDarkColor : themeTextColor,
      borderColor: themeColor
    },
    onClick: function onClick() {
      return props.setopenClose();
    }
  }, props.expandFlag ? _i18next["default"].t("lable.CLOSE") : _i18next["default"].t("lable.OPEN"))))));
};
var _default = ReportCardContent;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/ReportCardContent.js
 ** module id = 2396
 ** module chunks = 0
 **/